import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './css/typography.scss';
import loadEnv from './utilities/load-env';
import {Root} from './components/root';
import {UserHeader} from './components/user-header/user-header';
import {initI18N} from './utilities/i18n';
import {configureIdPortenUserManager} from './IdPortenUserManager';


loadEnv().then(async () => {
  configureIdPortenUserManager();
  await initI18N();
  ReactDOM.render(<Root/>, document.getElementById('root'));
  ReactDOM.render(<UserHeader/>, document.getElementById('user-header-root'));
});
